import React from 'react';
import { AlertCircle } from "lucide-react";
import { NavLink } from "react-router"
export default function Error() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center">
      <AlertCircle size={64} className="text-red-500 mb-4" />
      <h1 className="text-4xl font-bold">Oops! Page Not Found</h1>
      <p className="text-gray-600 mt-2">The page you are looking for does not exist.</p>
      <NavLink className="mt-4 px-6 py-2 bg-sky-500 text-white rounded-lg hover:bg-blue-600 transition" to="/" >Go Back Home</NavLink>
    </div>
  );
}